import { CustomPreloader } from '@components'
import settings from '@config/settings'
import { LogoDeleteIcon } from '@icons'
import { useMerchantLogo } from 'mmfintech-backend-api'
import { checkImageUpload, convertFileToBase64, tr } from 'mmfintech-commons'
import type { ErrorObjectType, UploadFileError } from 'mmfintech-commons/types'
import { ErrorDisplay, FileInput } from 'mmfintech-portal-commons'
import { useState } from 'react'
import './MerchantLogo.scss'

function MerchantLogo() {
  const [error, setError] = useState<ErrorObjectType | null>(null)

  const { logo, logoError, logoFetching, deleteLogo, deleteLogoError, updateLogo, updateLogoError } = useMerchantLogo()

  async function doUpdateLogo(data: unknown) {
    if (typeof data === 'string') updateLogo(data)
  }

  async function handleUpdate(list: File[]) {
    setError(null)
    convertFileToBase64(list[0]).then(doUpdateLogo)
  }

  async function handleDelete() {
    setError(null)
    deleteLogo()
  }

  function handleError(errors: UploadFileError | null) {
    if (errors) return setError(checkImageUpload(errors))
  }

  return (
    <>
      <div className='logo-wrapper'>
        {logoFetching ? (
          <div className='logo-loader'>
            <CustomPreloader />
          </div>
        ) : (
          <div className='logo-inner'>
            <FileInput
              maxNumber={1}
              onChange={handleUpdate}
              onError={handleError}
              maxFileSize={settings.logoMaxFileSize}
              acceptType={settings.logoAcceptType}
            >
              {({ onFileUpload }) =>
                logo ? (
                  <div className='logo-button image-item'>
                    <img src={logo} alt='' onClick={onFileUpload} data-test='logo-image' />
                    <div className='logo-remove-item' onClick={handleDelete} data-test='logo-delete-button'>
                      <LogoDeleteIcon />
                    </div>
                  </div>
                ) : (
                  <div className='logo-button bordered' onClick={onFileUpload}>
                    <span className='sign'>+</span>
                    <span className='caption'>{tr('PORTAL.COMPONENTS.LOGO.UPLOAD', 'Upload logo')}</span>
                  </div>
                )
              }
            </FileInput>
          </div>
        )}
      </div>

      <ErrorDisplay error={[error, logoError, updateLogoError, deleteLogoError]} className='text-center' />
    </>
  )
}

export default MerchantLogo
